import React, { useEffect, useMemo } from "react";
import translations from "../../../text/get-started-translations.json";
import language from '../../../utils/LanguageSettings';

const ChannelFilter: React.FC<{
  genres: string[];
  selectedCategory: string;
  onChannelGenreChange: (genre: string) => void;
  onLibraryGenreChange: (genre: string) => void;
  channelSelectedGenre: string;
  librarySelectedGenre: string;

}> = ({ genres, selectedCategory, onChannelGenreChange, onLibraryGenreChange, channelSelectedGenre, librarySelectedGenre }) => {
  const pageTranslations = translations[language];
  const channelGenres = useMemo(() => {
    return [
      {
        key: "Now Channels",
        value: pageTranslations.NowChannels
      },
      {
        key: "Movie/Drama",
        value: pageTranslations.MovieDrama
      },
      {
        key: "Travel/Documentary",
        value: pageTranslations.TravelDocumentary
      },
      {
        key: "News/Info",
        value: pageTranslations.NewsInfo
      },
      {
        key: "Kids/Learn",
        value: pageTranslations.KidsLearn
      },
      {
        key: "Entertainment/Leisure",
        value: pageTranslations.EntertainmentLeisure
      },
      {
        key: "Sports",
        value: pageTranslations.Sports
      },
      {
        key: "Foreign Language",
        value: pageTranslations.ForeignLanguage
      },
      {
        key: "Adult",
        value: pageTranslations.Adult
      }
    ];
  }, [pageTranslations]);

  const libraryGenres = useMemo(() => {
    return [
      {
        key: "Movie/Drama",
        value: pageTranslations.MovieDrama
      },
      {
        key: "Sports",
        value: pageTranslations.Sports
      },
      {
        key: "Asian Entertainment",
        value: pageTranslations.AsianEntertainment
      },
      {
        key: "Western Entertainment",
        value: pageTranslations.WesternEntertainment
      },
      {
        key: "Knowledge",
        value: pageTranslations.Knowledge
      },
      {
        key: "Kids/Learn",
        value: pageTranslations.KidsLearn
      },
      {
        key: "News",
        value: pageTranslations.News
      },
      {
        key: "Adult",
        value: pageTranslations.Adult
      }
    ];
  }, [pageTranslations]);

  useEffect(() => {
    const channel_select = document.getElementById("channel_select") as HTMLInputElement;
    if (channel_select) {
      selectedCategory === "channel" ? channel_select.value = channelSelectedGenre : channel_select.value = librarySelectedGenre;
    }
  }, [selectedCategory]);

  return (
    <div className="channel-filter container">
      <div className="row">
        <div className="col-auto">
          <label
            htmlFor="channel_select"
            className="text-16 genre col-form-label"
          >
            {pageTranslations.Genre}
          </label>
        </div>
        <div className="col-auto">
          {selectedCategory === "channel" && (
            <select
              className="form-select form-select-lg selectpicker text-16"
              id="channel_select"
              name="genre_selector"
              onChange={(e) => onChannelGenreChange(e.target.value)}
            >
              <option value="all">{pageTranslations.All}</option>
              {channelGenres.map((genre, index) => {
                const genreChecking = genres.filter((singleGenre: any) => singleGenre.toLowerCase() === genre.key.toLowerCase());
                if (genreChecking.length === 0) {
                  return null;
                }
                return (
                  <option key={index} value={genre.key}>
                    {genre.value}
                  </option>
                )
              })}
            </select>)
          }
          {selectedCategory === "on-demand" && (
            <select
              className="form-select form-select-lg selectpicker text-16"
              id="channel_select"
              name="genre_selector"
              onChange={(e) => onLibraryGenreChange(e.target.value)}

            >
              <option value="all">{pageTranslations.All}</option>
              {libraryGenres.map((genre, index) => {
                const genreChecking = genres.filter((singleGenre: any) => singleGenre.toLowerCase() === genre.key.toLowerCase());
                if (genreChecking.length === 0) {
                  return null;
                }
                return (
                  <option key={index} value={genre.key}>
                    {genre.value}
                  </option>
                )
              })}

            </select>)
          }
        </div>
      </div>
    </div>
  )
};

export default ChannelFilter;
